import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { NAV, CONTACT } from "@/data/site";
import { Logo } from "@/components/common/Logo";

const Col = ({ title, children }) => (
  <div>
    <h3 className="label-mono text-brand">{title}</h3>
    <div className="mt-5 space-y-2 text-sm text-steel">{children}</div>
  </div>
);

export const Footer = () => (
  <footer className="relative border-t border-canvas-line bg-canvas" data-testid="site-footer">
    <div className="mx-auto max-w-7xl px-5 py-16 sm:px-8 sm:py-20">
      <Link to="/careers" data-testid="footer-hiring-link"
        className="group mb-14 flex flex-col gap-3 border border-canvas-line p-6 transition-colors duration-300 hover:border-brand sm:flex-row sm:items-center sm:justify-between">
        <span className="flex items-center gap-3">
          <span className="h-2 w-2 animate-pulse bg-leaf" aria-hidden />
          <span className="font-display text-2xl font-bold uppercase">We're hiring</span>
        </span>
        <span className="flex items-center gap-2 text-sm text-steel group-hover:text-ink">
          Qualified Plumber · Site Foreman · General Operative <ArrowUpRight className="h-4 w-4" />
        </span>
      </Link>
      <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-4">
        <div>
          <Logo testid="footer-logo" />
          <p className="mt-6 max-w-xs text-sm leading-relaxed text-steel">
            Mechanical and renewable contractors for housing schemes, apartments and commercial construction in Dublin and surrounding counties.
          </p>
        </div>
        <Col title="Site">
          {NAV.map((n) => (
            <Link key={n.to} to={n.to} className="block hover:text-ink" data-testid={`footer-nav-${n.label.toLowerCase()}`}>{n.label}</Link>
          ))}
          <Link to="/privacy" className="block hover:text-ink" data-testid="footer-nav-privacy">Privacy notice</Link>
        </Col>
        <Col title="Office">
          {CONTACT.address.map((l) => <p key={l}>{l}</p>)}
          <p className="pt-2">{CONTACT.hours}</p>
        </Col>
        <Col title="Contact">
          {CONTACT.phones.map((p) => (
            <a key={p.label} href={`tel:${p.tel}`} className="block hover:text-ink" data-testid={`footer-phone-${p.label.toLowerCase()}`}>{p.label}: {p.value}</a>
          ))}
          <a href={`mailto:${CONTACT.enquiriesEmail}`} className="block pt-2 text-ink hover:text-brand" data-testid="footer-email">{CONTACT.enquiriesEmail}</a>
          <div className="flex gap-5 pt-3">
            <a href={CONTACT.linkedin} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 hover:text-ink" data-testid="footer-linkedin">LinkedIn <ArrowUpRight className="h-3.5 w-3.5" /></a>
            <a href={CONTACT.facebook} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 hover:text-ink" data-testid="footer-facebook">Facebook <ArrowUpRight className="h-3.5 w-3.5" /></a>
          </div>
        </Col>
      </div>
      <div className="mt-16 flex flex-col gap-2 border-t border-canvas-line pt-6 text-xs text-steel sm:flex-row sm:justify-between">
        <span>© {new Date().getFullYear()} Ramor Renewables Heating &amp; Plumbing Ltd. All rights reserved.</span>
        <span className="label-mono">RGI · SEAI · OFTEC · F-Gas</span>
      </div>
    </div>
  </footer>
);
